export const PollModuleChild = {
	name: 'page-poll-custom-job-evaluation',
	path: 'custom-job-evaluation/:id',
	meta: {
		title: 'Resolver encuesta',
	},
	components: {
		customPoll: () => import('../pages/JobEvaluationPollPage'),
	},
};


export default {};



// WEBPACK FOOTER //
// ./src/modules/polls/router/index.js